'use strict';
import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';

angular
  .module('flowingly.runner.directives')
  .component('flowTimelineFilelistAttachDocument', {
    bindings: {
      files: '<'
    },
    controller: [
      'sessionService',
      'fileService',
      function (
        sessionService: SharedAngular.SessionService,
        fileService: SharedAngular.FileService
      ) {
        const ctrl = this;
        ctrl.user = sessionService.getUser();

        init();

        function init() {
          for (let f = 0; f < ctrl.files.length; f++) {
            const fileId = ctrl.files[f].fileId;
            ctrl.files[f].downloadLink = fileId
              ? fileService.getDownloadLink(fileId)
              : undefined;
          }
        }
      }
    ],
    template: `
                    <div ng-repeat="file in $ctrl.files">
                      <a flow-download-link="{{::file.downloadLink}}" title="{{::file.fileName}}" target="_blank"> {{::file.fileName}}</a>
                    </div>
                `
  });
